// /src/components/imovel/cadastro/EtapaIdentificacaoArsenal.jsx
// VERSÃO 12.0 SUPREMA - FAST CADASTRO + DATA POWER (quantidadegb)

import React, { useEffect } from 'react';
import { InputField, SelectField, TextareaField } from './FormControls';
import { 
    FiHash, FiTarget, FiShield, FiType, FiLayers, FiTag, FiStar, 
    FiBriefcase, FiFileText, FiAward, FiRefreshCw, FiUser, FiZap,
    FiPhone, FiMessageCircle, FiShare2, FiGlobe, FiSmartphone, FiPlusCircle, FiActivity, FiDatabase
} from 'react-icons/fi';

export default function EtapaIdentificacaoArsenal({ 
    formData, 
    handleChange, 
    currentSubtipos,
    opcoesNegocio,
    opcoesPrincipal,
    promocoesElite
}) {

    // 🤖 GATILHO DE AUTOMAÇÃO TÁTICA
    // Se flegado "Portabilidade" no Tipo de Oferta, ativa o gatilho de circuito automaticamente.
    useEffect(() => {
        if (formData.tipoNegocio === 'Portabilidade' && formData.isPortabilidade !== 'Sim') {
            handleChange({ target: { name: 'isPortabilidade', value: 'Sim' } });
        }
    }, [formData.tipoNegocio]);

    const yesNoOptions = [
        { value: 'Sim', label: 'SIM' },
        { value: 'Não', label: 'NÃO' }
    ];

    const handleToggle = (name, currentValue) => {
        const newValue = currentValue === 'Sim' || currentValue === true ? 'Não' : 'Sim';
        handleChange({ target: { name, value: newValue } });
    };

    return (
        <div className="w-full space-y-8 animate-in fade-in zoom-in-95 duration-700 pb-20">
            
            {/* 🛰️ HEADER COMPACTO */}
            <div className="flex items-center gap-4 mb-8 border-b border-white/5 pb-6">
                <div className="w-12 h-12 rounded-2xl bg-accent/10 border border-accent/20 flex items-center justify-center text-accent shadow-xl">
                    <FiActivity size={24} />
                </div>
                <div>
                    <h2 className="text-2xl font-black uppercase tracking-tighter leading-none">FAST <span className="text-accent">CADASTRO</span></h2>
                    <p className="text-[9px] font-black uppercase tracking-[0.3em] opacity-40">Protocolo de Registro Unificado TIM UNITY</p>
                </div>
            </div>

            {/* 🟦 BLOCO 01: DNA BÁSICO (Identidade, Dados e Gestão) */}
            <div className="bg-white/[0.02] border border-white/5 p-6 rounded-[32px] space-y-8">
                <div className="flex items-center gap-2 mb-2">
                    <FiType size={14} className="text-accent" />
                    <span className="text-[10px] font-black uppercase tracking-widest opacity-60">Identidade e Franquia</span>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-end">
                    {/* Título Principal */}
                    <div className="col-span-12 lg:col-span-9">
                        <InputField name="titulo" value={formData.titulo} onChange={handleChange} placeholder="Ex: TIM Black Empresas 6GB (1GB + 5GB Bônus)" required className="font-bold text-lg" />
                    </div>

                    {/* Destaque Toggle */}
                    <div className="col-span-12 lg:col-span-3">
                        <ToggleButton 
                            label={formData.isDestaque ? 'Destaque: ON' : 'Destaque: OFF'} 
                            isActive={formData.isDestaque} 
                            onClick={() => handleChange({ target: { name: 'isDestaque', value: !formData.isDestaque } })}
                            icon={FiStar}
                        />
                    </div>

                    {/* 🚀 QUANTIDADE DE GB (O Novo Batedor) */}
                    <div className="col-span-12 md:col-span-2">
                        <Label text="Potência (GB)" icon={FiDatabase} />
                        <InputField 
                            name="quantidadegb" 
                            type="number"
                            value={formData.quantidadegb} 
                            onChange={handleChange} 
                            placeholder="Ex: 50" 
                            required 
                        />
                    </div>

                    {/* SKU / Ref */}
                    <div className="col-span-12 md:col-span-3">
                        <Label text="Referência SKU" />
                        <InputField name="codigoImovel" value={formData.codigoImovel} onChange={handleChange} placeholder="SKU-XXXX" required />
                    </div>

                    {/* Unidade de Gestão */}
                    <div className="col-span-12 md:col-span-4">
                        <Label text="Unidade de Gestão" />
                        <InputField name="nomeImobiliaria" value={formData.nomeImobiliaria} onChange={handleChange} />
                    </div>

                    {/* Matrícula */}
                    <div className="col-span-12 md:col-span-3">
                        <Label text="Matrícula Operador" />
                        <InputField name="creci" value={formData.creci} onChange={handleChange} placeholder="MAT-0000" />
                    </div>
                </div>
            </div>

            {/* 🟥 BLOCO 02: CIRCUITO E OFERTA */}
            <div className="bg-accent/5 border border-accent/10 p-6 rounded-[32px] space-y-8">
                <div className="flex items-center gap-2 mb-2">
                    <FiZap size={14} className="text-accent" />
                    <span className="text-[10px] font-black uppercase tracking-widest text-accent">Inteligência de Venda</span>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
                    <div className="col-span-12 md:col-span-4 space-y-4">
                        <Label text="Tipo de Oferta" />
                        <SelectField name="tipoNegocio" value={formData.tipoNegocio} onChange={handleChange} options={opcoesNegocio} required />
                    </div>
                    <div className="col-span-12 md:col-span-4 space-y-4">
                        <Label text="Público Alvo" />
                        <SelectField name="tipoPrincipal" value={formData.tipoPrincipal} onChange={handleChange} options={opcoesPrincipal} required />
                    </div>
                    <div className="col-span-12 md:col-span-4 space-y-4">
                        <Label text="Ativação / Entrega" />
                        <SelectField name="subtipo" value={formData.subtipo} onChange={handleChange} options={currentSubtipos.map(st => ({ value: st, label: st }))} required />
                    </div>

                    <div className="col-span-12 grid grid-cols-1 md:grid-cols-3 gap-4 pt-4 border-t border-white/5">
                        <ToggleButton 
                            label="Canal VIP" 
                            isActive={formData.isVIP === 'Sim'} 
                            onClick={() => handleToggle('isVIP', formData.isVIP)}
                            icon={FiAward}
                            color="var(--accent-color)"
                        />
                        <ToggleButton 
                            label="Portabilidade" 
                            isActive={formData.isPortabilidade === 'Sim'} 
                            onClick={() => handleToggle('isPortabilidade', formData.isPortabilidade)}
                            icon={FiRefreshCw}
                            color="#3b82f6"
                        />
                        <ToggleButton 
                            label="Cliente TIM CPF" 
                            isActive={formData.isClienteTIM_CPF === 'Sim'} 
                            onClick={() => handleToggle('isClienteTIM_CPF', formData.isClienteTIM_CPF)}
                            icon={FiUser}
                            color="#10b981"
                        />
                    </div>
                </div>
            </div>

            {/* 🟨 BLOCO 03: ARSENAL TÉCNICO */}
            <div className="bg-white/[0.02] border border-white/5 p-6 rounded-[32px] space-y-8">
                <div className="flex items-center gap-2 mb-2">
                    <FiLayers size={14} className="text-accent" />
                    <span className="text-[10px] font-black uppercase tracking-widest opacity-60">Destaques e Specs</span>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <InputField name="beneficio1" value={formData.beneficio1} onChange={handleChange} placeholder="Benefício 1" />
                    <InputField name="beneficio2" value={formData.beneficio2} onChange={handleChange} placeholder="Benefício 2" />
                    <InputField name="beneficio3" value={formData.beneficio3} onChange={handleChange} placeholder="Benefício 3" />
                    <InputField name="beneficio4" value={formData.beneficio4} onChange={handleChange} placeholder="Benefício 4" />
                </div>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 pt-4 border-t border-white/5">
                    <div className="space-y-2">
                        <Label text="Voz Ilimitada" />
                        <SelectField name="quartos" value={formData.quartos} onChange={handleChange} options={yesNoOptions} />
                    </div>
                    <div className="space-y-2">
                        <Label text="WhatsApp/Waze" />
                        <SelectField name="suites" value={formData.suites} onChange={handleChange} options={yesNoOptions} />
                    </div>
                    <div className="space-y-2">
                        <Label text="Redes Sociais" />
                        <SelectField name="banheiros" value={formData.banheiros} onChange={handleChange} options={yesNoOptions} />
                    </div>
                    <div className="space-y-2">
                        <Label text="Roaming Nac." />
                        <SelectField name="areaTotal" value={formData.areaTotal} onChange={handleChange} options={yesNoOptions} />
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="space-y-2">
                        <Label text="Apps Inclusos" />
                        <InputField name="vagasGaragem" value={formData.vagasGaragem} onChange={handleChange} placeholder="Skeelo, Banca..." />
                    </div>
                    <div className="space-y-2">
                        <Label text="Vantagens Extras" />
                        <InputField name="areaUtil" value={formData.areaUtil} onChange={handleChange} placeholder="Gestor Digital..." />
                    </div>
                </div>
            </div>

            {/* ⬛ BLOCO 04: NARRATIVA */}
            <div className="bg-white/[0.02] border border-white/5 p-6 rounded-[32px] space-y-4">
                <div className="flex items-center gap-2 mb-2">
                    <FiFileText size={14} className="text-accent" />
                    <span className="text-[10px] font-black uppercase tracking-widest opacity-60">Narrativa Comercial</span>
                </div>
                <TextareaField 
                    name="descricao" 
                    value={formData.descricao || ''} 
                    onChange={handleChange} 
                    placeholder="Regras de bônus e fidelidade..." 
                    rows={5}
                />
            </div>

        </div>
    );
}

// 🛰️ SUB-COMPONENTE: LABEL DNA
const Label = ({ text, icon: Icon }) => (
    <div className="flex items-center gap-2 mb-2 ml-1">
        {Icon && <Icon size={10} className="text-accent opacity-50" />}
        <label className="text-[9px] font-black uppercase tracking-[0.2em] opacity-50 block">{text}</label>
    </div>
);

// 🕹️ SUB-COMPONENTE: TOGGLE BUTTON
const ToggleButton = ({ label, isActive, onClick, icon: Icon, color = "var(--accent-color)" }) => (
    <button 
        type="button" 
        onClick={onClick} 
        className="w-full h-[58px] rounded-2xl border transition-all duration-300 flex items-center justify-between px-5 group"
        style={{ 
            backgroundColor: isActive ? `${color}15` : 'transparent',
            borderColor: isActive ? color : 'rgba(255,255,255,0.05)',
        }}
    >
        <div className="flex items-center gap-3">
            <Icon size={16} style={{ color: isActive ? color : 'rgba(255,255,255,0.2)' }} />
            <span className={`text-[10px] font-black uppercase tracking-widest ${isActive ? 'text-white' : 'opacity-30'}`}>
                {label}
            </span>
        </div>
        <div className={`w-3 h-3 rounded-full border-2 transition-all ${isActive ? 'bg-white border-white' : 'border-white/5'}`} />
    </button>
);